import {
  PublicServiceConfig,
  PublicServiceEntity,
} from '@/lib/models/policy-model/public-services';

export const buildServiceAccess = (
  current: PublicServiceConfig | undefined,
  selectedIds: string[],
  aclVariant: 'allow' | 'block',
  defaultAllowAction: 'protected' | 'monitored' = 'protected'
): PublicServiceEntity[] => {
  const serviceAccess = current?.serviceAccess ?? [];

  if (aclVariant === 'block') {
    const alternateEntities = serviceAccess.filter((entity) =>
      ['protected', 'monitored'].includes(entity.action)
    );
    const ourEntities: PublicServiceEntity[] = selectedIds.map((serviceId) => ({
      serviceId,
      action: 'blocked',
    }));
    return [...alternateEntities, ...ourEntities];
  }

  const alternateEntities = serviceAccess.filter((entity) => entity.action === 'blocked');
  const ourEntities: PublicServiceEntity[] = selectedIds.map((serviceId) => {
    const existing = serviceAccess.find(
      (entity) =>
        entity.serviceId === serviceId && ['protected', 'monitored'].includes(entity.action)
    );
    return {
      serviceId,
      action: existing?.action ?? defaultAllowAction,
    };
  });
  return [...alternateEntities, ...ourEntities];
};
